<template>
  <ProductReadMore
    :is-truncated="isDescriptionTruncated"
    :show-toggle="showMoreToggle"
    :limit="readMoreLimit"
    :toggle-text="readMoreToggleText"
  >
    <div class="wysiwyg" v-html="desc"></div>
    <ul v-if="detailedMedia.length > 0" class="images">
      <li v-for="image in detailedMedia" :key="image.image.media">
        <img :src="image.image.media" />
      </li>
    </ul>
    <template #expanded>
      <ul v-if="bullets.length > 0" class="bullets">
        <li v-for="bullet in bullets" :key="bullet" class="bullets__bullet">
          {{ bullet }}
        </li>
      </ul>
    </template>
  </ProductReadMore>
</template>

<script>
import { mapState } from "vuex";
import { unwrapNodes } from "@/helpers/graphql";
import ProductReadMore from "@/components/product-display/ProductReadMore.vue";

export default {
  name: "ProductDetails",
  components: {
    ProductReadMore,
  },
  props: {
    showReadMore: {
      type: Boolean,
      default: false,
    },
    readMoreLimit: {
      type: Number,
      default: 7,
    },
    readMoreToggleText: {
      type: Object,
      default: () => ({
        readMore: "Read More",
        readLess: "Read Less",
      }),
    },
  },
  computed: {
    ...mapState("product", ["product"]),
    desc() {
      return this.product.descriptionHtml;
    },
    detailedMedia() {
      return unwrapNodes(this.product.detailedMedia?.references?.edges) || [];
    },
    bullets() {
      try {
        const bullletValue = this.product.bullets?.value;

        if (bullletValue) {
          return JSON.parse(bullletValue);
        }

        return [];
      } catch (error) {
        console.error("Error parsing", error);
        return [];
      }
    },
    showMoreToggle() {
      return (
        this.showReadMore && (this.bullets.length > 0 || this.desc.length > 300)
      );
    },
    isDescriptionTruncated() {
      return this.showReadMore && this.desc.length > 300;
    },
  },
};
</script>

<style lang="scss" scoped>
.wysiwyg {
  margin-bottom: 24px;
}
.wysiwyg :deep() {
  p {
    @include editorial-body(16px);
    @include respond-above(md) {
      font-size: 20px;
    }
  }

  *:last-child {
    margin-bottom: 0;
  }
}

.images {
  display: flex;
  overflow-x: auto;
  flex-flow: row nowrap;
  margin-bottom: 24px;

  & > * {
    flex: 1 0 auto;
    max-width: 250px;
  }
}

.bullets {
  padding: 0 0 0 15px;
  &__bullet {
    @include utility-body(14px);
    list-style: disc;
    padding: 0;
    margin: 0;
  }
}
</style>
